import { c as _c } from "react/compiler-runtime";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import Link from 'next/link';
import { Fragment, useEffect, useRef, useState } from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
export function DropDown(t0) {
  const $ = _c(16);
  const {
    handleMenu
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleClickOutside = function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t2 = [dropdownRef];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [{
      name: "IEP Goal Tracking",
      link: "/blog/tag/iep-goal-tracking"
    }, {
      name: "IEP Data Collection",
      link: "/blog/tag/iep-data-collection"
    }, {
      name: "IEP Compliance",
      link: "/blog/tag/iep-compliance"
    }, {
      name: "IDEA",
      link: "/blog/tag/idea"
    }];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const menuItems = t3;
  let t4;
  if ($[3] !== isOpen) {
    t4 = event_0 => {
      event_0.stopPropagation();
      setIsOpen(!isOpen);
    };
    $[3] = isOpen;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="relative flex items-center"><>More<MdOutlineKeyboardArrowDown /></></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <MenuButton as="button" className="flex items-center text-lg" onClick={t4}>{t5}</MenuButton>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isOpen && true;
  let t8;
  if ($[8] !== handleMenu) {
    t8 = <MenuItems as="div" className="absolute -left-1 top-8 cursor-pointer rounded-md bg-[#393838] p-3 text-white md:-left-4 md:top-8 lg:-left-11 lg:top-8">{menuItems.map((item, index) => <Link key={index} href={`${item.link}`}><MenuItem><span className="flex items-start justify-start whitespace-nowrap rounded-lg p-1 hover:bg-gray-primary" onClick={() => {
            setIsOpen(false);
            handleMenu(false);
          }}>{item.name}</span></MenuItem></Link>)}</MenuItems>;
    $[8] = handleMenu;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <Transition as={Fragment} show={t7} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">{t8}</Transition>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <div ref={dropdownRef}><Menu as="div" className="relative z-10">{t6}{t9}</Menu></div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}